import { ERROR_TYPES } from 'constants/errors';

import AppError from './AppError';

class HttpError extends AppError {
  constructor(code = 500, description = '') {
    super();

    this.code = code;
    this.type = ERROR_TYPES.HTTP_ERROR;
    this.description = `${code} ${description}`;
  }
}

export default HttpError;
